import { isNil, isUndefined, keyBy } from 'lodash'
import { ApiSchemas } from '..'
import { client } from '../client'
import { wrapEndpoint } from '../wrap'

export default {
  async get(id: number) {
    return wrapEndpoint(() =>
      client.GET('/lme-attachment/{id}', {
        params: {
          path: {
            id,
          },
        },
      }),
    )
  },

  async aggregate(query: ApiSchemas['AggregateLmeAttachmentDto']) {
    return wrapEndpoint(() => client.GET('/lme-attachment/aggregate', { params: { query } }))
  },

  async list(query?: ApiSchemas['ListLmeAttachmentDto']) {
    return wrapEndpoint(() =>
      client.GET('/lme-attachment', {
        params: {
          query,
        },
      }),
    )
  },

  async createMany(body: ApiSchemas['CreateManyLmeAttachmentDto']) {
    return wrapEndpoint(() =>
      client.POST('/lme-attachment', {
        body,
        bodySerializer(body) {
          const formData = new FormData()
          body.stateIds.forEach((stateId, index) => {
            formData.append(`stateIds.${index}`, stateId)
          })
          body.diseaseIds.forEach((diseaseId, index) => {
            formData.append(`diseaseIds.${index}`, diseaseId.toString())
          })
          body.files.forEach((file, index) => {
            formData.append(`files.${index}`, file as unknown as File)
          })
          return formData
        },
      }),
    )
  },

  async update(id: number, body: ApiSchemas['UpdateLmeAttachmentDto']) {
    return wrapEndpoint(() =>
      client.PUT('/lme-attachment/{id}', {
        params: {
          path: {
            id,
          },
        },
        body,
      }),
    )
  },

  async delete(id: number) {
    await wrapEndpoint(() =>
      client.DELETE('/lme-attachment/{id}', {
        params: {
          path: {
            id,
          },
        },
      }),
    )
  },
}
